import React, { ReactNode, useEffect, useRef, useState } from "react";

import { TooltipWrapper } from "components";

/* 
Remember to set:
.tooltip-span {
    display: unset;
    .className {
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}
*/

export const OverflowEllipsisWithTooltip = ({
  children,
  className = "",
  title,
  verticalOverflow = false,
}: {
  children: ReactNode;
  className?: string;
  title: string;
  verticalOverflow?: boolean;
}) => {
  const spanRef = useRef<HTMLSpanElement>(null);
  const [isOverflowed, setIsOverflowed] = useState(false);

  useEffect(() => {
    const el = spanRef.current;
    if (el) setIsOverflowed(verticalOverflow ? el.scrollHeight > el.clientHeight : el.scrollWidth > el.clientWidth);
  }, [title, verticalOverflow]);

  return (
    <TooltipWrapper tooltip={{ title: isOverflowed ? title : undefined }} className={`tooltip-span ${className}`}>
      <span ref={spanRef} className={className}>
        {children}
      </span>
    </TooltipWrapper>
  );
};

export default OverflowEllipsisWithTooltip;
